"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var createUniqueId = function createUniqueIdHelper() {
  for (var _len = arguments.length, ids = new Array(_len), _key = 0; _key < _len; _key++) {
    ids[_key] = arguments[_key];
  }

  return ids.reduce(function (id, argument) {
    return id + argument;
  }, '').replace(/(\s)/g, '').toLowerCase();
};

var _default = createUniqueId;
exports["default"] = _default;